import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { initGA, trackPageView } from '@/utils/analytics';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import SolutionsPage from '@/pages/PricingPage';
import TermsPage from '@/pages/TermsPage';
import PrivacyPage from '@/pages/PrivacyPage';
import RefundPage from '@/pages/RefundPage';
import ShippingPage from '@/pages/ShippingPage';
import BlogRedirectPage from '@/pages/BlogRedirectPage';
import NotFoundPage from '@/pages/NotFoundPage';
import LoginRedirectPage from '@/pages/LoginRedirectPage';
// import ServicesPage from '@/pages/ServicesPage';
import MentorshipSignupPage from '@/pages/MentorshipSignupPage';
import MentorshipInfoPage from '@/pages/MentorshipInfoPage';
import DLPPage from '@/pages/DLP';
import DPPNotesInfoPage from '@/pages/DPPNotesInfoPage';
import TestSeriesInfoPage from '@/pages/TestSeriesInfoPage';

// Component to scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Track page views on route change
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA on component mount
    initGA();
    
    // Track the initial pageview
    trackPageView(window.location.pathname + window.location.search);
    
    // Set up history listener for subsequent pageviews
    const handleRouteChange = () => {
      trackPageView(window.location.pathname + window.location.search);
    };
    
    window.addEventListener('popstate', handleRouteChange);
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  // Track page view when location changes
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <PageViewTracker />
      <ScrollToTop />
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/refund" element={<RefundPage />} />
          <Route path="/shipping" element={<ShippingPage />} />
          <Route path="/blog" element={<BlogRedirectPage />} />
          <Route path="/login" element={<LoginRedirectPage />} />
          {/* <Route path="/services" element={<ServicesPage />} /> */}
          <Route path="/mentorship-signup" element={<MentorshipSignupPage />} />
          <Route path="/mentorship-info" element={<MentorshipInfoPage />} />
          <Route path="/dlp" element={<DLPPage />} />
          <Route path="/dpp-notes-info" element={<DPPNotesInfoPage />} />
          <Route path="/test-series-info" element={<TestSeriesInfoPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;